module.exports = __webpack_public_path__ + "media/stylesheets/images/main/openWaiting/openWaiting_mobile_cook2-d1d21ebc27ba9d39b1aeab7433126f53.png";